import { CABINET_BASE_URL } from "@/config/const";
import { RegionTreeItem, UserData } from "@/types";
import apiService from "../api.service";
import { IinBinParams } from "./types";
const baseURL = `${CABINET_BASE_URL}rest/userregistration/`;

export default {
  async user(p: IinBinParams) {
    return (await apiService.get(`${baseURL}user`, { params: p })).data;
  },
  async password(p: IinBinParams) {
    return (await apiService.get(`${baseURL}password`, { params: p })).data;
  },
  async region(): Promise<RegionTreeItem[]> {
    return (await apiService.get(`${baseURL}region`)).data;
  },
  async xml(userDataDto: UserData) {
    return (await apiService.post(`${baseURL}xml`, userDataDto)).data;
  },
  async guidXml() {
    return (await apiService.post(`${baseURL}guid_xml`)).data;
  },
  async register(xmlData: string) {
    return (await apiService.post(`${baseURL}`, { xmlData })).data;
  },
  async getCertificate(xmlData: string) {
    return (await apiService.post(`${baseURL}/certificate`, { xmlData })).data;
  },
};
